export default __webpack_public_path__ + "static/media/24_gallery.c680b959.jpg";